import { Component, Input, QueryList, ViewChildren } from '@angular/core';
import {
  WarningArrayItemDeletionComponent,
} from '../../../../warning-array-item-deletion/warning-array-item-deletion.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  RolloverSharesClassOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-shares-class.options';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import { RolloverShareClassFormComponent } from '../rollover-share-class-form/rollover-share-class-form.component';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";


@Component({
  selector: 'app-rollover-share-classes-form',
  templateUrl: './rollover-share-classes-form.component.html',
  styleUrls: ['./rollover-share-classes-form.component.scss'],
  standalone: false,
})
export class RolloverShareClassesFormComponent {

  @ViewChildren('shareClass')
  shareClassComponents: QueryList<RolloverShareClassFormComponent>;

  @Input()
  form: AdvancedForm<RolloverOptions>;

  constructor(public modalService: NgbModal) {
  }

  get shareClasses(): AdvancedFormArray<RolloverSharesClassOptions> {
    return this.form.formElements.sharesClasses as AdvancedFormArray<RolloverSharesClassOptions>;
  }

  addShareClass() {
    this.shareClasses.appendNew();
  }

  async removeShareClass(shareClassIndexToRemove: number) {
    const modal = this.modalService.open(WarningArrayItemDeletionComponent);
    (modal.componentInstance as WarningArrayItemDeletionComponent).objectDefinition = 'cette catégorie d\'actions';
    modal.closed.subscribe(async result => {
      if (result === true) {
        // Here we delete only in the form, not syncing the change to the server or else deleting could cause bad data to be sync.
        this.shareClasses.delete(shareClassIndexToRemove);

        return;
      }
    });

    return;
  }

  // refresh(){
  //     this.shareClassComponents.forEach(item => item.refresh());
  // }

}
